import React, {useEffect} from "react";
import { AiOutlinePoweroff } from "react-icons/ai";
import Logout from "../../pages/Common/Logout";
// import { IoSearchOutline } from "react-icons/io5";

export default function SearchBar({ searchQuery, setSearchQuery }) {

  const handleLogout = () => {
   
    console.log('Logout successful in SearchBar component');
    
  };
  
  return (
     <div className="flex justify-end w-full gap-x-6">

         <div className="relative ml-4 flex justify-start items-center gap-x-4">
          {/* <IoSearchOutline className="absolute text-2xl ml-3 text-[#7B7B7B]" /> */}
          <input
            value={searchQuery}
            onChange={(e)=>setSearchQuery(e.target.value)}
            className="px-4 py-1 w-[20rem] rounded-lg"
            type="text"
            placeholder="Search"
          />
          
        </div >
        <button>
        <Logout onLogout={handleLogout} />
      </button>
        
     </div>
       
  );
}
